var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 471.3 500",
    style: {
      enableBackground: "new 0 0 471.3 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#103DAF;}\n\t.st1{fill:#5895FF;}\n\t.st2{fill:#FFFFFF;fill-opacity:0.4;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:#1E49D3;enable-background:new    ;}\n\t.st5{fill:#043017;}\n\t.st6{fill:#157241;}\n\t.st7{fill:#34935F;}\n\t.st8{fill:#07542A;}\n\t.st9{fill:#BC3228;}\n\t.st10{fill:#F45B42;}\n\t.st11{fill:#CC493B;}\n\t.st12{fill:#F98073;}\n\t.st13{fill:#073551;}\n\t.st14{fill:#48A8FF;}\n\t.st15{fill:#2477B5;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "0,268.1 80.7,229.8 80.7,268.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "471.3,268.1 390.5,229.8 390.5,268.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M276.4,1.6l163,166v273.9c0,32.1-25.5,58.1-57,58.1H89c-31.5,0-57-26-57-58.1V59.7c0-32.1,25.5-58.1,57-58.1 H276.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M439.4,167.5H336.3c-31.5,0-59.9-28.9-59.9-61V1.6L439.4,167.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 268.1,
    className: "st11",
    width: 471.3,
    height: 156.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M193.2,342.3c-2,3.7-5.1,6.7-9.4,8.9c-4.3,2.3-9.6,3.4-16.1,3.4h-13.2v30.3h-15.8v-78.8h29 c6.1,0,11.3,1.1,15.6,3.2c4.3,2.1,7.5,5,9.7,8.7c2.1,3.7,3.2,7.9,3.2,12.5C196.2,334.7,195.2,338.6,193.2,342.3z M176.8,338.9 c2.1-2,3.2-4.8,3.2-8.4c0-7.7-4.3-11.5-12.9-11.5h-12.5v22.9H167C171.4,341.9,174.6,340.9,176.8,338.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M256.8,310.9c6.3,3.2,11.1,7.8,14.6,13.8c3.4,6,5.1,12.9,5.1,20.8c0,7.9-1.7,14.8-5.1,20.7 c-3.4,5.9-8.3,10.5-14.6,13.7c-6.3,3.2-13.6,4.9-21.8,4.9h-27.6v-78.8h27.6C243.2,306.1,250.5,307.7,256.8,310.9z M253.5,364.7 c4.5-4.5,6.8-10.9,6.8-19.1c0-8.2-2.3-14.6-6.8-19.3c-4.5-4.6-10.9-6.9-19.2-6.9h-11.2v52.1h11.2 C242.6,371.4,249,369.2,253.5,364.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M337,306.1v12.8h-32.9V339h25.2v12.5h-25.2v33.3h-15.8v-78.8H337z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M162.2,219.4L162.2,219.4c0,5.7-4.6,10.4-10.4,10.4H91.1c-5.7,0-10.4-4.6-10.4-10.4v0 c0-5.7,4.6-10.4,10.4-10.4h60.7C157.6,209,162.2,213.7,162.2,219.4z M243.7,177.9L243.7,177.9c0,5.7-4.6,10.4-10.4,10.4H91.1 c-5.7,0-10.4-4.6-10.4-10.4v0c0-5.7,4.6-10.4,10.4-10.4h142.2C239.1,167.6,243.7,172.2,243.7,177.9z M243.7,136.4L243.7,136.4 c0,5.7-4.6,10.4-10.4,10.4H91.1c-5.7,0-10.4-4.6-10.4-10.4v0c0-5.7,4.6-10.4,10.4-10.4h142.2C239.1,126.1,243.7,130.7,243.7,136.4z  M243.7,94.9L243.7,94.9c0,5.7-4.6,10.4-10.4,10.4H91.1c-5.7,0-10.4-4.6-10.4-10.4v0c0-5.7,4.6-10.4,10.4-10.4h142.2 C239.1,84.6,243.7,89.2,243.7,94.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcPdf);
export default __webpack_public_path__ + "static/media/ac_pdf.68fa3bb8619a572f944baa8ac529e248.svg";
export { ForwardRef as ReactComponent };